import { ArticleTabStyles } from './tabs.style';
import { TabProps } from './types';

// --------------------------------------------------------------------------

const { TabsContent, Article } = ArticleTabStyles;

// --------------------------------------------------------------------------

const ArticlesTab = ({ id, articles, className, onClick }: TabProps) => {
  return (
    <TabsContent className={className} value={id}>
      {articles?.map((article) => (
        <Article key={article.title} {...article} onClickArticle={onClick} />
      ))}
    </TabsContent>
  );
};

// --------------------------------------------------------------------------

export default ArticlesTab;
